import Layout from '@/layout'

const supplierRouter = {
  path: '/supplier-parts',
  component: Layout,
  redirect: '/supplier-parts',
  name: 'supplier-parts',
  meta: {
    title: 'routeSysSupplierManage',
    icon: 'user11'
  },
  children: [
    {
      path: 'sys-supplier-list',
      component: () => import('@/views/supplier-parts/supplier-list/sys-supplier-list'),
      name: 'Syssupplierlist',
      meta: { title: 'routeSysSupplier', icon: 'icons10', code: 'supplier:std:management'  }
    },
    {
      path: 'sys-supplierpart-list',
      component: () => import('@/views/supplier-parts/supplierpart-list/sys-supplierpart-list'),
      name: 'Syssupplierpartlist',
      meta: { title: 'routeSysMaintain', icon: 'icons111', code: 'supplier:name:management' }
    },
    {
      path: 'sys-category-list',
      component: () => import('@/views/supplier-parts/category-list/sys-category-list'),
      name: 'Syscategorylist',
      meta: { title: 'routeSysCategory', icon: 'icons112', code: 'supplier:rel:management' }
    },
    {
      path: 'sys-partControl-list',
      component: () => import('@/views/supplier-parts/partControl-list/sys-partControl-list'),
      name: 'SysPartControllist',
      meta: { title: 'routeSysPartControl', icon: 'icons62', code: 'supplier:flag:management' }
    },
    {
      path: 'sys-controlCategory-list',
      component: () => import('@/views/supplier-parts/controlCategory-list/sys-controlCategory-list'),
      name: 'SysControlCategory',
      meta: { title: 'routeSysControlCategory', icon: 'icons114', code: 'rel:flag:management' }
    }
  ]
}

export default supplierRouter
